module.exports = __webpack_public_path__ + "img/ard-logo.367267da.jpg";